import { Routes as ReactRoutes, Route, BrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import { GoogleAnalytics } from '@lair-finance/google'
import { DefaultLayout } from '@/app/layouts/DefaultLayout.tsx'
import { RestakeLayout } from '@/app/layouts/RestakeLayout.tsx'
import { AppLayout } from '@/app/layouts/AppLayout.tsx'
import { GameLayout } from '@/modules/game/app/layouts/GameLayout.tsx'
import { AuthorizedRoute } from '@/modules/game/app/layouts/AuthorizedRoute.tsx'
import { isProduction } from '@/shared/constants/env.ts'

const RouteMain = lazy(() => import('@/routes/Main'))
const RouteStake = lazy(() => import('@/routes/Stake'))
const RouteUnstake = lazy(() => import('@/routes/Unstake'))
const RouteClaim = lazy(() => import('@/routes/Claim'))
const RouteRestake = lazy(() => import('@/routes/Restake'))
const RouteRestakeDetail = lazy(() => import('@/routes/Restake/Detail'))
const RouteRestakeUnstake = lazy(() => import('@/routes/Restake/Unstake'))
const RouteFarm = lazy(() => import('@/routes/Farm'))
const RouteReward = lazy(() => import('@/routes/Reward'))
const RouteEarn = lazy(() => import('@/routes/Earn'))
const RouteAirdrops = lazy(() => import('@/routes/Airdrops'))
const RouteLair = lazy(() => import('@/routes/Lair'))
const RouteLairClaim = lazy(() => import('@/routes/Lair/claim'))
const RouteChecker = lazy(() => import('@/routes/Checker'))
const RouteLr = lazy(() => import('@/routes/Lr'))
const RouteLrClaim = lazy(() => import('@/routes/Lr/claim'))
const RouteError404 = lazy(() => import('@/routes/404.tsx'))
const RouteMultiSender = lazy(() => import('@/routes/Tool/MultiSender.tsx'))
const RouteAVS = lazy(() => import('@/routes/Tool/AVS.tsx'))
const RouteBridge = lazy(() => import('@/routes/Bridge'))

const RouteGameConnect = lazy(() => import('@/modules/game/routes/Connect'))
const RouteGameMain = lazy(() => import('@/modules/game/routes/Main'))

export default function Routes() {
  return (
    <BrowserRouter>
      <GoogleAnalytics gaId={'G-L0PWQ9L7ZK'} enabled={isProduction} />
      <ReactRoutes>
        <Route element={<AppLayout />}>
          <Route element={<DefaultLayout containerClassName={'max-w-[570px]'} />}>
            <Route index element={<RouteMain />} />
            <Route path={'stake'} element={<RouteStake />} />
            <Route path={'unstake'} element={<RouteUnstake />} />
            <Route path={'claim'} element={<RouteClaim />} />
            <Route path={'restake'}>
              <Route path={':tokenId'}>
                <Route index element={<RouteRestakeDetail />} />
                <Route path={'unstake'} element={<RouteRestakeUnstake />} />
              </Route>
            </Route>
            <Route path={'tool'}>
              <Route path={'multi-sender'} element={<RouteMultiSender />} />
              <Route path={'avs/:address/:roundIndex'} element={<RouteAVS />} />
            </Route>
          </Route>
          <Route element={<RestakeLayout containerClassName={'max-w-[1200px]'} />}>
            <Route path={'restake'} index element={<RouteRestake />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[648px]'} />}>
            <Route path={'bridge'} element={<RouteBridge />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[762px]'} />}>
            <Route path={'checker'} element={<RouteChecker />} />
            <Route path={'lr/:id'} element={<RouteLrClaim />} />
            <Route path={'lair/:id'} element={<RouteLairClaim />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[1200px]'} />}>
            <Route path={'farm'} element={<RouteFarm />} />
            <Route path={'reward'} element={<RouteReward />} />
            <Route path={'earn'} element={<RouteEarn />} />
            <Route path={'airdrops'} element={<RouteAirdrops />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'!p-0'} noContainer />}>
            <Route path={'lair'} element={<RouteLair />} />
            <Route path={'game/lair'} element={<RouteLair />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'!p-0'} noContainer noFooter />}>
            <Route path={'lr'} element={<RouteLr />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'sm:pt-20'} />}>
            <Route path={'*'} element={<RouteError404 />} />
          </Route>
        </Route>
        <Route path={'game'} element={<GameLayout />}>
          <Route index element={<RouteGameConnect />} />
          <Route element={<AuthorizedRoute />}>
            <Route path={'main'} element={<RouteGameMain />} />
          </Route>
        </Route>
      </ReactRoutes>
    </BrowserRouter>
  )
}
